export enum UploadType {
  'Set Upload' = 'BOM_DATA',
  'Device Upload' = 'DEVICE_DATA',
  'Set Attachments' = 'BOM_ATTACHMENT',
  'Device Attachments' = 'DEVICE_ATTACHMENT',
  'Set Serial Numbers' = 'USS_DATA',
}

export enum UploadTypeMapping {
  DEVICE_DATA = 'Device Upload',
  BOM_DATA = 'Set Upload',
  DEVICE_ATTACHMENT = 'Device Attachments',
  BOM_ATTACHMENT = 'Set Attachments',
  USS_DATA = 'Set Serial Numbers',
}

export enum FilterStatus {
  ACTION_REQUIRED = 'Action required',
  MERGED = 'Merged',
  PENDING = 'Pending',
  FAILED = 'Failed',
  SUCCESS = 'Success',
}

export interface setPreview {
  set_code: string;
  description?: string;
  num_trays: number;
  num_devices: number;
}

export interface BulkUploadSetIgnore {
  set_code: string;
  description: string;
  num_trays: number;
  num_devices: number;
  reason: string;
}

export interface BulkUploadSetUpdate {
  existing_data: setPreview;
  updated_data: setPreview;
}

export enum BulkUploadStatus {
  UPLOAD_CHECK_STARTED = 'UPLOAD_CHECK_STARTED',
  UPLOAD_CHECK_FAILED = 'UPLOAD_CHECK_FAILED',
  UPLOAD_CHECK_COMPLETE = 'UPLOAD_CHECK_COMPLETE',
  UPLOAD_COMPLETE = 'UPLOAD_COMPLETE',
  UPLOAD_STARTED = 'UPLOAD_STARTED',
  DRAFT_UPLOAD_STARTED = 'DRAFT_UPLOAD_STARTED',
  DRAFT_UPLOAD_COMPLETE = 'DRAFT_UPLOAD_COMPLETE',
  DRAFT_UPLOAD_PARTIAL_SUCCESS = 'DRAFT_UPLOAD_PARTIAL_SUCCESS',
  DRAFT_UPLOAD_FAILED = 'DRAFT_UPLOAD_FAILED',
  MERGE_STARTED = 'MERGE_STARTED',
  MERGE_COMPLETE = 'MERGE_COMPLETE',
}

export enum CheckStatus {
  UPLOAD_CHECK_STARTED = 'Checks started',
  UPLOAD_CHECK_FAILED = 'Checks Failed',
  UPLOAD_CHECK_COMPLETE = 'Action Required',
  UPLOAD_COMPLETE = 'Completed',
  UPLOAD_STARTED = 'Pending',
  DRAFT_UPLOAD_STARTED = 'Draft Upload Started',
  DRAFT_UPLOAD_COMPLETE = 'Draft Upload Complete',
  DRAFT_UPLOAD_PARTIAL_SUCCESS = 'Draft Upload Partial Success',
  DRAFT_UPLOAD_FAILED = 'Draft Upload Failed',
  MERGE_STARTED = 'Merge Started',
  MERGE_COMPLETE = 'Merge Complete',
}

export enum FileStatus {
  DRAFT_INITIALIZED = 'DRAFT_INITIALIZED',
  DRAFT_FAILED = 'DRAFT_FAILED',
  DRAFT_COMPLETED = 'DRAFT_COMPLETED',
  DRAFT = 'DRAFT',
  MERGE_STARTED = 'MERGE_STARTED',
  MERGE_FAILED = 'MERGE_FAILED',
  MERGED = 'MERGED',
  DELETED = 'DELETED',
  SAVED = 'SAVED',
}

export enum CheckStatusMapping {
  'Checks started' = 'UPLOAD_CHECK_STARTED',
  'Checks Failed' = 'UPLOAD_CHECK_FAILED',
  'Action Required' = 'UPLOAD_CHECK_COMPLETE',
  'Completed' = 'UPLOAD_COMPLETE',
  'Pending' = 'UPLOAD_STARTED',
  'Draft Upload Started' = 'DRAFT_UPLOAD_STARTED',
  'Draft Upload Complete' = 'DRAFT_UPLOAD_COMPLETE',
  'Draft Upload Partial Success' = 'DRAFT_UPLOAD_PARTIAL_SUCCESS',
  'Draft Upload Failed' = 'DRAFT_UPLOAD_FAILED',
  'Merge Started' = 'MERGE_STARTED',
  'Merge Complete' = 'MERGE_COMPLETE',
}

export interface BulkUploadResult {
  upload_uuid: string;
  upload_name: string;
  status: BulkUploadStatus;
}

export interface BulkUploadCompleteResult {
  upload_uuid: string;
  total_merged: number;
  total_failed: number;
  result: BulkUploadResult[];
}

export interface BulkUploadType {
  upload_id: string;
  total_uploaded_items: number;
  filename: string;
  uploaded_file_location: string;
  status: BulkUploadStatus;
  upload_type: UploadType;
  created_by: string;
  created_at: string;
}

//MERGE: this may not be needed anymore - came from old branch
export interface UploadDataAction {
  upload_id: string;
  upload_name: string;
  type: UploadType;
  status: BulkUploadStatus;
  gcs_location: string;
  csv_location: number;
}

export interface UploadListResponse {
  bulk_uploads: BulkUploadType[];
}

export interface UploadFileResponse {
  upload_id: string;
  status: BulkUploadStatus;
}

export interface MergeAllDraftSetsResponse {
  status: BulkUploadStatus;
}

export interface MergeAllDraftPartsResponse {
  status: BulkUploadStatus;
}

export interface uniqueSet {
  set_code: string;
  description?: string;
  num_trays: number;
  num_devices: number;
}

export interface updateSet {
  set_id: string;
  description: string;
  num_trays: number;
  num_devices: number;
}

export interface ignoreSet {
  set_id: string;
  description: string;
  num_parts: number;
  reason: string;
}

export interface checkStatusParts {
  unique: ItemType[];
  update: ItemType[];
  ignore: ItemType[];
}
export interface uniquePart {
  device_id: string;
  description: string;
  num_parts: number;
}

export interface SetAttachment {
  file_path: string;
  set_code: string;
  tray_ref?: string;
  existing_gs_location?: string;
  reason?: string;
}

export interface PartAttachment {
  file_path: string;
  existing_gs_location?: string;
  reason?: string;
}

export interface uniquePartAttachment {
  attachment_name: string;
  attachment_url: string;
}

export interface updateSet {
  existing_data: uniqueSet;
  updated_data: uniqueSet;
}

export interface updatePart {
  existing_data: uniquePart;
  updated_data: uniquePart;
}

export interface ignoreSet {
  set_code?: string;
  description: string;
  num_trays?: number;
  num_devices?: number;
  reason: string;
}

export interface updatePart {
  device_id?: string;
  description?: string;
  num_parts?: number;
  reason: string;
}

export interface ignorePart {
  device_id?: string;
  description?: string;
  num_parts?: number;
  reason: string;
}
export interface CheckStatusSets {
  unique: uniqueSet[];
  update: updateSet[];
  ignore: ignoreSet[];
}

export interface CheckStatusParts {
  unique: uniquePart[];
  update: updatePart[];
  ignore: ignorePart[];
}

export interface CheckStatusSetAttachments {
  unique: SetAttachment[];
  update: SetAttachment[];
  ignore: SetAttachment[];
}

export interface CheckStatusPartAttachments {
  unique: PartAttachment[];
  update: PartAttachment[];
  ignore: PartAttachment[];
}

export interface GetUploadChecksResultsResponse {
  upload_type: UploadType;
  sets?: CheckStatusSets;
  parts?: CheckStatusParts;
  set_attachments?: CheckStatusSetAttachments;
  part_attachments?: CheckStatusPartAttachments;
}

export interface ItemType {
  id?: string;
  device_id: string;
  file_path?: string;
  attachment_type?: string;
  display_code?: string;
  existing_gs_location: string;
  set_code?: string;
  description?: string;
  num_parts?: number;
  reason?: string;
  num_trays?: number;
  num_devices?: number;
  existing_data?: ItemType;
  updated_data?: ItemType;
  updated: boolean;
  updateItem: boolean;
  uniqueItem: boolean;
  new_gs_location?: string;
  set_serial?: string;
  set_name?: string;
  set_uss?: string; // only when UploadType['Set Serial Numbers']
}

export interface BulkUploadSuccessInfo {
  item_ref: string;
}

export interface BulkUploadFailInfo {
  item_ref: string;
  error_message: string;
}

export interface GetUploadResultsResponse {
  upload_id: string;
  upload_name: string;
  upload_type: UploadType;
  total_items?: number;
  succeeded: BulkUploadSuccessInfo[];
  failed: BulkUploadFailInfo[];
}

export interface BulkMergeSuccessInfo {
  item_ref: string;
  merged_id: string;
}

export interface GetMergeResultsResponse {
  upload_id: string;
  upload_name: string;
  upload_type: UploadType;
  total_items: number;
  succeeded: BulkMergeSuccessInfo[];
  failed: BulkUploadFailInfo[];
}

export type GetSetUploadDataResponse = UploadDataAction[];
